/**
 * Smart Chart Container
 * Uses BrokerChart (Lightweight Charts) for ALL instruments
 * This ensures spreads and virtual prices are reflected in the chart
 * 
 * Now unified - BIST stocks also use BrokerChart like other instruments
 */
import { memo, useMemo } from 'react';
import BrokerChart from './BrokerChart';

const ChartContainer = ({ symbol = 'EUR/USD', instrumentData = null, priceData = null, fitContainer = false, onNewOrder }) => {
  // Calculate spread from price data
  const spread = useMemo(() => {
    if (priceData?.bid && priceData?.ask) {
      return priceData.ask - priceData.bid;
    }
    return 0;
  }, [priceData]);

  // Use BrokerChart for ALL instruments (unified experience)
  return (
    <div key={`broker-${symbol}`} className="w-full h-full relative">
      <BrokerChart 
        fitContainer={fitContainer}
        onNewOrder={onNewOrder}
        symbol={symbol} 
        priceData={priceData}
        spread={spread}
        isVirtual={Boolean(instrumentData?.is_virtual || priceData?.is_virtual)}
      />
    </div>
  );
};

export default memo(ChartContainer);
